<template>
  <div>

      <div class="rg-top-filter pt-1 float-right pl-3"
        :class="(($vuetify.breakpoint.mobile) ? '-mt-2' : '')"
      >
          <v-text-field
              :value="formatDate(date_filter[0], 'MMM DD, YYYY') + '   -   ' + ((date_filter[1]) ? formatDate(date_filter[1], 'MMM DD, YYYY') : '')"
              append-icon="mdi-calendar-blank-outline"
              readonly
              outlined
              dense
              style="width: 230px; background: #4EC5A1; color: #FFFFFF !important; border: 0px !important;"
              hide-details
              placholder="Choose Date"
              @click="show_picker = !show_picker"
          ></v-text-field>
          
          <div v-if="show_picker" style="position: absolute; width: 490px; z-index: 999; margin-left: -260px; background: #FFFFFF; padding: 10px; margin-top: 5px; border-radius: 10px; box-shadow: 0px 0px 30px 0px #E2E2E2;">
            <div style="float: left; border-right: solid 1px #d5d5d5;">
              <div class="mb-2"><strong class="text-sm">Filter by Date</strong></div>

              <v-date-picker
              v-model="date_filter"
              range
              no-title
              scrollable
              @input="menu = false"
              style="border: 0px;"
              >
              <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="#44468F"
                      @click="show_picker = false"
                  >
                      Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="#44468F"
                      @click="filterDate();"
                  >
                      UPDATE
                  </v-btn>
              </v-date-picker>
            </div>

            <div style="float: left; margin-left: 20px; padding-left: 20px; padding-top: 20px;">
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Week')" :style="((selected_date_text == 'This Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Week</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Week')" :style="((selected_date_text == 'Last Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Week</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Month')" :style="((selected_date_text == 'This Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Month</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Month')" :style="((selected_date_text == 'Last Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Month</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 30 days')" :style="((selected_date_text == 'Last 30 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 30 days</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 60 days')" :style="((selected_date_text == 'Last 60 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 60 days</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 90 days')" :style="((selected_date_text == 'Last 90 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 90 days</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Year')" :style="((selected_date_text == 'This Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Year</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Year')" :style="((selected_date_text == 'Last Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Year</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 6 months')" :style="((selected_date_text == 'Last 6 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 6 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 12 months')" :style="((selected_date_text == 'Last 12 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 12 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 24 months')" :style="((selected_date_text == 'Last 24 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 24 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 36 months')" :style="((selected_date_text == 'Last 36 months') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 36 months</a></div>
              <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('All Time')" :style="((selected_date_text == 'All Time') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">All Time</a></div>
            </div>

            <div style="clear: both;"></div>
          </div>
      </div>

      <div class="rg-top-filter pt-1 float-right">
        <v-select
          outlined
          dense
          hide-details
          label=""
          class="white header-inputs"
          :items="['Frequency: Auto', 'Daily', 'Weekly', 'Monthly', 'Yearly']"
          v-model="selected_frequency"
          @change="loadDashboard()"
        ></v-select>
      </div>

      <h1 v-if="!loading && me" class="text-lg font-semibold mb-3">{{ me.company_name }} <span style="font-size: 14px;"> - {{ me.city }}<span v-if="me.integrations && me.integrations.google_ads && me.integrations.google_ads.settings.selected_client_id"> - {{ me.integrations.google_ads.settings.selected_client_id }}</span></span></h1>

      <v-container v-if="loading" style="padding: 10px !important;">
        <br clear="all" /><br clear="all" />
      <v-row class="">
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>

    <div v-else>

      <div style="clear: both;"></div>

      <div v-if="me && me.free_user" class="pt-3">
        <div class="flex flex-row flex-wrap w-full">
          <div class="dashboard-box stats-box w-full">
            <v-card class="pa-2" tile style="background: #b3f5e1 !important;">
              <div class="p-2 pl-3">
                <div class="dashboard-box-title" style="color: #000000 !important; opacity: 1 !important; font-size: 20px; margin-bottom: 10px;">Usage</div>

                <div class="flex flex-row flex-wrap w-full">
                  <div class="w-full">
                    <div style="padding-right: 10px; clear: both; height: 30px; margin-top: 5px; color: #000000; font-size: 12px;">
                      <div>{{ me.voice_usage + me.message_usage }} of {{ getLimit() }} {{ limitOfWhat() }} used</div>

                      <div class="pt-2">
                        <v-progress-linear
                          rounded
                          :value="((me.voice_usage + me.message_usage)/getLimit()) * 100"
                          color="#4EC5A1"
                          background-color="grey lighten-2" 
                          height="22"
                        ></v-progress-linear>
                      </div>
                    </div>
                  </div>

                  <br clear="all" /><br clear="all" />
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mt-1" v-if="me && me.integrations && me.integrations.google_ads && !me.integrations.google_ads.settings.selected_client_id">
          <div class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mt-6" role="alert">
              <div><strong>Note!</strong> Currently your LSA account is not attached to your account and you are only using the AI part of our software. Please connect your LSA account in settings or contact your account manager to help you set it up.</div>
            </div>
        </div>
      </div>

      <div class="-mx-2">
        <div class="flex flex-row flex-wrap w-full">
          <div class="dashboard-box stats-box w-full md:w-1/2 lg:w-1/2 pt-3 px-2">
            <v-card class="pa-2" tile style="background: #4E7FC5 !important;">
              <div class="p-2 pl-3">
                <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important; font-size: 20px; margin-bottom: 10px;">Leads</div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 8px;">Total Leads: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : this.dashboard_data.total_leads) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 8px;"
                  :style="((this.dashboard_data.total_leads < this.dashboard_data_prev.total_leads) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.total_leads < this.dashboard_data_prev.total_leads) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_leads }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 8px;">Total Calls: {{ ((this.dashboard_data.total_calls == 0 && 0) ? '-' : this.dashboard_data.total_calls) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 8px;"
                  :style="((this.dashboard_data.total_calls < this.dashboard_data_prev.total_calls) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.total_calls < this.dashboard_data_prev.total_calls) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_calls }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 8px;">Total Connected Calls: {{ ((this.dashboard_data.total_connected_calls == 0 && 0) ? '-' : this.dashboard_data.total_connected_calls) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 8px;"
                  :style="((this.dashboard_data.total_connected_calls < this.dashboard_data_prev.total_connected_calls) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.total_connected_calls < this.dashboard_data_prev.total_connected_calls) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_connected_calls }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 8px;">Message Leads: {{ ((this.dashboard_data.total_message_leads == 0 && 0) ? '-' : this.dashboard_data.total_message_leads) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 8px;"
                  :style="((this.dashboard_data.total_message_leads < this.dashboard_data_prev.total_message_leads) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.total_message_leads < this.dashboard_data_prev.total_message_leads) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_message_leads }}%
                </div>

                <div style="clear: both;"></div>
                
              </div>
            </v-card>
          </div>

          <div class="dashboard-box stats-box w-full md:w-1/2 lg:w-1/2 pt-3 px-2">
            <v-card class="pa-2" tile style="background: #334257 !important;">
              <div class="p-2 pl-3">
                <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important; font-size: 20px; margin-bottom: 10px;">Conversion</div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Qualified Leads: {{ ((this.dashboard_data.stats.charged_leads == 0 && 0) ? '-' : this.dashboard_data.stats.charged_leads) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.charged_leads < this.dashboard_data_prev.stats.charged_leads) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.charged_leads < this.dashboard_data_prev.stats.charged_leads) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.charged_leads }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Approved Credits: {{ ((this.dashboard_data.stats.approved_disputes == 0 && 0) ? '-' : this.dashboard_data.stats.approved_disputes) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.approved_disputes < this.dashboard_data_prev.stats.approved_disputes) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.approved_disputes < this.dashboard_data_prev.stats.approved_disputes) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.approved_disputes }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">
                  <v-tooltip right color="primary">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <span style="cursor: pointer; text-decoration: underline;">Converted Customers:</span> {{ dashboard_data.stats.converted_customers }}
                        </div>
                    </template>

                    <span>
                        <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"><strong>Intake Conversion:</strong> {{ dashboard_data.stats.converted_customers_non_ai }}</div>

                        <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                          :style="((this.dashboard_data.stats.converted_customers_non_ai < this.dashboard_data_prev.stats.converted_customers_non_ai) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                        >
                          <i :class="((this.dashboard_data.stats.converted_customers_non_ai < this.dashboard_data_prev.stats.converted_customers_non_ai) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                          {{ comparisons.converted_customers_non_ai }}%
                        </div>
                        <div style="clear: both;"></div>

                        <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"><strong>AI Captured Conversion:</strong> {{ dashboard_data.stats.converted_customers_ai }}</div>

                        <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                          :style="((this.dashboard_data.stats.converted_customers_ai < this.dashboard_data_prev.stats.converted_customers_ai) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                        >
                          <i :class="((this.dashboard_data.stats.converted_customers_ai < this.dashboard_data_prev.stats.converted_customers_ai) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                          {{ comparisons.converted_customers_ai }}%
                        </div>
                        <div style="clear: both;"></div>
                    </span>
                  </v-tooltip>
                  
                </div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.converted_customers < this.dashboard_data_prev.stats.converted_customers) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.converted_customers < this.dashboard_data_prev.stats.converted_customers) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.converted_customers }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">
                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <span style="cursor: pointer; text-decoration: underline;">Total Converted Value:</span> {{ ((dashboard_data.total_leads == 0 && 0) ? '-' : '$' + dashboard_data.stats.total_converted_value) }}
                          </div>
                      </template>

                      <span>
                          <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"><strong>ROI:</strong> {{ dashboard_data.stats.roi }}</div>

                          <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                            :style="((dashboard_data.stats.roi < dashboard_data_prev.stats.roi) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                          >
                            <i :class="((dashboard_data.stats.roi < dashboard_data_prev.stats.roi) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                            {{ comparisons.roi }}
                          </div>
                          <div style="clear: both;"></div>
                      </span>
                    </v-tooltip>
                </div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.conversion < this.dashboard_data_prev.stats.conversion) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.conversion < this.dashboard_data_prev.stats.conversion) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.conversion }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Conversion Rate: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : this.dashboard_data.stats.conversion + '%') }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.total_converted_value < this.dashboard_data_prev.stats.total_converted_value) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.total_converted_value < this.dashboard_data_prev.stats.total_converted_value) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_converted_value }}%
                </div>

                <div style="clear: both;"></div>
                
              </div>
            </v-card>
          </div>

          <div class="dashboard-box stats-box w-full md:w-1/2 lg:w-1/2 pt-3 px-2">
            <v-card class="pa-2" tile style="background: #476072 !important;">
              <div class="p-2 pl-3">
                <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important; font-size: 20px; margin-bottom: 10px;">Response Rate</div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Response Rate: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : this.dashboard_data.stats.lsa_response_rate + '%') }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.lsa_response_rate < this.dashboard_data_prev.stats.lsa_response_rate) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.lsa_response_rate < this.dashboard_data_prev.stats.lsa_response_rate) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.lsa_response_rate }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Under 30 seconds Call Response Rate: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : this.dashboard_data.stats.lsa_30_seconds_response_rate + '%') }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.lsa_30_seconds_response_rate < this.dashboard_data_prev.stats.lsa_30_seconds_response_rate) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.lsa_30_seconds_response_rate < this.dashboard_data_prev.stats.lsa_30_seconds_response_rate) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.lsa_30_seconds_response_rate }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Messages Response Time: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : this.dashboard_data.stats.lsa_messages_response_rate + ' Hours') }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.lsa_messages_response_rate < this.dashboard_data_prev.stats.lsa_messages_response_rate) ? 'color: #c9ffc4;' : 'color: rgb(255 0 37);')"
                >
                  <i :class="((this.dashboard_data.stats.lsa_messages_response_rate < this.dashboard_data_prev.stats.lsa_messages_response_rate) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.lsa_messages_response_rate }}%
                </div>

                <div style="clear: both;"></div>
                
              </div>
            </v-card>
          </div>

          <div class="dashboard-box stats-box w-full md:w-1/2 lg:w-1/2 pt-3 px-2">
            <v-card class="pa-2" tile style="background: #548CA8 !important;">
              <div class="p-2 pl-3">
                <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important; font-size: 20px; margin-bottom: 10px;">Metrics</div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Total Impressions: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : this.dashboard_data.stats.total_impressions.toLocaleString()) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.total_impressions < this.dashboard_data_prev.stats.total_impressions) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.total_impressions < this.dashboard_data_prev.stats.total_impressions) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_impressions }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Total Clicks: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : this.dashboard_data.stats.total_clicks.toLocaleString()) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.total_clicks < this.dashboard_data_prev.stats.total_clicks) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.total_clicks < this.dashboard_data_prev.stats.total_clicks) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_clicks }}%
                </div>

                <div style="clear: both;"></div>

                <div class="details-box top-heading" style="color: #FFFFFF !important; float: left; font-size: 12px; margin-top: 3px;">Total Cost: {{ ((this.dashboard_data.total_leads == 0 && 0) ? '-' : '$' + this.dashboard_data.stats.total_cost.toLocaleString()) }}</div>

                <div class="details-box comparison" style="color: #FFFFFF; float: left; font-size: 11px; margin-left: 14px; margin-top: 3px;"
                  :style="((this.dashboard_data.stats.total_cost < this.dashboard_data_prev.stats.total_cost) ? 'color: rgb(255 0 37);' : 'color: #c9ffc4;')"
                >
                  <i :class="((this.dashboard_data.stats.total_cost < this.dashboard_data_prev.stats.total_cost) ? 'mdi mdi-arrow-bottom-right' : 'mdi mdi-arrow-top-right')"></i>
                  {{ comparisons.total_cost }}%
                </div>

                <div style="clear: both;"></div>
                
              </div>
            </v-card>
          </div>
        </div>
      </div>

      <div class="flex flex-row flex-wrap mt-6">
          <div class="dashboard-box stats-box w-full">
              <v-card class="pa-2" tile style="background: rgba(200, 221, 253, 0.87);">
                <div class="details-box pl-3 pt-3 pb-3" style="color: #000000; font-weight: bold;">Performance Over Time</div>
              </v-card>
          </div>
      </div>

      <div class="flex flex-row flex-wrap mt-5">
          <div class="dashboard-box stats-box w-full mb-4" :class="(($vuetify.breakpoint.mobile) ? 'pr-0 mb-5' : '')">
              <v-card
                class="pa-2"
                tile
              >
                <div class="pl-3 pt-3">
                  <div class="dashboard-box-title mb-1">Performance Over Time</div>
                    <div v-if="this.dashboard_data.total_leads == 0 && 0">
                      <br /><br /><br /><br /><br />
    
                      <div class="dashboard-box-iconsquare">
                        <div class="dashboard-box-icon-background"></div>
                        <div class="dashboard-box-icon">
                          <i class="mdi mdi-pulse"></i>
                        </div>
                      </div>
            
                      <div style="text-align: center;">
                        <div class="pt-2 pb-2">
                          <strong>No Data Yet</strong>
                        </div>
            
                        <div class="text-sm mb-4 text-gray-600">
                          There is no data available for the selected selected period.
                        </div>
                      </div>
                      
                      <br /><br /><br /><br /><br />
                    </div>

                    <div v-else class="-mt-5 -ml-4 -mb-2">
                        <apexchart
                            :options="lineChartOptions"
                            :series="lineChartSeries"
                            type="line"
                            height="375"
                        />
                    </div>
                  </div>
              </v-card>
          </div>
        </div>

      <div class="flex flex-row flex-wrap mt-6">
          <div class="dashboard-box stats-box w-full">
              <v-card class="pa-2" tile style="background: rgba(200, 221, 253, 0.87);">
                <div class="details-box pl-3 pt-3 pb-3" style="color: #000000; font-weight: bold;">Lead Volume Over Time</div>
              </v-card>
          </div>
      </div>

      <div class="flex flex-row flex-wrap mt-5">
          <div class="dashboard-box stats-box w-full mb-4" :class="(($vuetify.breakpoint.mobile) ? 'pr-0 mb-5' : '')">
              <v-card
                class="pa-2"
                tile
              >
                <div class="pl-3 pt-3">
                  <div class="dashboard-box-title mb-1">Lead Volume Over Time</div>
                    <div v-if="this.dashboard_data.total_leads == 0 && 0">
                      <br /><br /><br /><br /><br />
    
                      <div class="dashboard-box-iconsquare">
                        <div class="dashboard-box-icon-background"></div>
                        <div class="dashboard-box-icon">
                          <i class="mdi mdi-pulse"></i>
                        </div>
                      </div>
            
                      <div style="text-align: center;">
                        <div class="pt-2 pb-2">
                          <strong>No Data Yet</strong>
                        </div>
            
                        <div class="text-sm mb-4 text-gray-600">
                          There is no data available for the selected selected period.
                        </div>
                      </div>
                      
                      <br /><br /><br /><br /><br />
                    </div>

                    <div v-else class="-mt-5 -ml-4 -mb-2">
                        <apexchart
                            :options="lineChartLeadVolumeOptions"
                            :series="lineChartLeadVolumeSeries"
                            type="line"
                            height="375"
                        />
                    </div>
                  </div>
              </v-card>
          </div>
        </div>

      <div class="flex flex-row flex-wrap mt-2">
          <div class="dashboard-box stats-box w-full">
              <v-card class="pa-2" tile style="background: rgba(200, 221, 253, 0.87);">
                <div class="details-box pl-3 pt-3 pb-3" style="color: #000000; font-weight: bold;">Metrics Over Time</div>
              </v-card>
          </div>
      </div>

      <div class="flex flex-row flex-wrap mt-5">
        <div class="dashboard-box stats-box w-full mb-4" :class="(($vuetify.breakpoint.mobile) ? 'pr-0 mb-5' : '')">
            <v-card
              class="pa-2"
              tile
            >
              <div class="pl-3 pt-3">
                <div class="dashboard-box-title mb-1">Metrics Over Time</div>
                  <div v-if="this.dashboard_data.total_leads == 0 && 0">
                    <br /><br /><br /><br /><br />
  
                    <div class="dashboard-box-iconsquare">
                      <div class="dashboard-box-icon-background"></div>
                      <div class="dashboard-box-icon">
                        <i class="mdi mdi-pulse"></i>
                      </div>
                    </div>
          
                    <div style="text-align: center;">
                      <div class="pt-2 pb-2">
                        <strong>No Data Yet</strong>
                      </div>
          
                      <div class="text-sm mb-4 text-gray-600">
                        There is no data available for the selected selected period.
                      </div>
                    </div>
                    
                    <br /><br /><br /><br /><br />
                  </div>

                  <div v-else class="-mt-5 -ml-4 -mb-2">
                      <apexchart
                          :options="lineChartMetricsOptions"
                          :series="lineChartMetricsSeries"
                          type="line"
                          height="375"
                      />
                  </div>
                </div>
            </v-card>
        </div>
      </div>

      <div class="flex flex-row flex-wrap mt-2">
          <div class="dashboard-box stats-box w-full">
              <v-card class="pa-2" tile style="background: rgba(200, 221, 253, 0.87);">
                <div class="details-box pl-3 pt-3 pb-3" style="color: #000000; font-weight: bold;">Metrics By Tag</div>
              </v-card>
          </div>
      </div>

      <div class="flex flex-row flex-wrap mt-5">
        <div class="dashboard-box stats-box w-full mb-4" :class="(($vuetify.breakpoint.mobile) ? 'pr-0 mb-5' : '')">
            <v-card
              class="pa-2"
              tile
            >
              <div class="pl-3 pt-3">
                <div class="dashboard-box-title mb-1">Metrics By Tag</div>
                  <div class="-mt-5 -ml-4 -mb-2" v-if="showBubbleChart">
                      <div style="width:650px; max-width: 100%; margin: auto;">
                        <iframe style="width: 100%;" height="550" :src="'https://call-tag-bubble-chart-542.created.app?embed=true&tags=' + bubbleTags" title="BubbleChart" frameBorder="0"></iframe>
                      </div>

                      <div style="width: 100%; background: #FFFFFF; height: 100px; margin-top: -100px; position: absolute;"></div>
                  </div>
                </div>
            </v-card>
        </div>
      </div>

      <div class="flex flex-row flex-wrap mt-2">
          <div class="dashboard-box stats-box w-full">
              <v-card class="pa-2" tile style="background: rgba(200, 221, 253, 0.87);">
                <div class="details-box pl-3 pt-3 pb-3" style="color: #000000; font-weight: bold;">LSA Leads Status</div>
              </v-card>
          </div>
      </div>

      <div class="flex flex-row flex-wrap mb-1 mt-5">
          <div class="dashboard-box stats-box w-full mb-4 md:w-1/2 lg:w-1/2 pr-3" :class="(($vuetify.breakpoint.mobile) ? 'pr-0' : '')">
              <v-card class="pa-2" tile>
                  <div class="dashboard-box-title pt-3 pl-3">Credits</div>

                  <div v-if="this.dashboard_data.total_leads == 0 && 0">
                    <br /><br /><br /><br /><br />
  
                    <div class="dashboard-box-iconsquare">
                      <div class="dashboard-box-icon-background"></div>
                      <div class="dashboard-box-icon">
                        <i class="mdi mdi-pulse"></i>
                      </div>
                    </div>
          
                    <div style="text-align: center;">
                      <div class="pt-2 pb-2">
                        <strong>No Data Yet</strong>
                      </div>
          
                      <div class="text-sm mb-4 text-gray-600">
                        There is no data available for the selected selected period.
                      </div>
                    </div>
                    
                    <br /><br /><br /><br /><br />
                  </div>

                  <div v-else class="-mt-5 -ml-1 -mb-2">
                      <apexchart
                          :options="chartOneOptions"
                          :series="chartOneSeries"
                          type="line"
                          height="400"
                      />
                  </div>
              </v-card>
          </div>
          <div class="dashboard-box stats-box w-full mb-4 md:w-1/2 lg:w-1/2 pl-2" >
              <v-card class="pa-2" tile>
                  <div class="dashboard-box-title pt-3 pl-3">Leads</div>

                  <div v-if="this.dashboard_data.total_leads == 0 && 0">
                    <br /><br /><br /><br /><br />
  
                    <div class="dashboard-box-iconsquare">
                      <div class="dashboard-box-icon-background"></div>
                      <div class="dashboard-box-icon">
                        <i class="mdi mdi-pulse"></i>
                      </div>
                    </div>
          
                    <div style="text-align: center;">
                      <div class="pt-2 pb-2">
                        <strong>No Data Yet</strong>
                      </div>
          
                      <div class="text-sm mb-4 text-gray-600">
                        There is no data available for the selected selected period.
                      </div>
                    </div>
                    
                    <br /><br /><br /><br /><br />
                  </div>

                  <div v-else class="-mt-5 -ml-1 -mb-2">
                      <apexchart
                          :options="chartTwoOptions"
                          :series="chartTwoSeries"
                          type="bar"
                          height="400"
                      />
                  </div>
              </v-card>
          </div>
      </div>

      <div class="-mx-2">
        <div class="flex flex-row flex-wrap mb-1 mt-1">
            <div class="dashboard-box stats-box w-full mb-3 px-2">
              <v-card class="pa-2" tile style="background: #9FC543;">
                <div class="details-box pl-3 pt-3 pb-3" style="color: #FFFFFF; font-weight: bold;">LSA Reviews</div>
              </v-card>
            </div>
        </div>
      </div>

      <div class="-mx-2">
        <div class="flex flex-row flex-wrap mt-1">
          <div class="dashboard-box stats-box w-full mb-4 px-2" :class="(($vuetify.breakpoint.mobile) ? 'pr-0' : '')" style="height: 380px;overflow: hidden;">
            <v-card
              class="pa-2"
              tile
            >
              <div class="pl-3 pt-3">
                <div class="dashboard-box-title mb-1">Overall Ratings</div>

                <div v-if="this.dashboard_data.total_leads == 0 && 0">
                  <br /><br /><br /><br /><br />

                  <div class="dashboard-box-iconsquare">
                    <div class="dashboard-box-icon-background"></div>
                    <div class="dashboard-box-icon">
                      <i class="mdi mdi-pulse"></i>
                    </div>
                  </div>

                  <div style="text-align: center;">
                    <div class="pt-2 pb-2">
                      <strong>No Data Yet</strong>
                    </div>

                    <div class="text-sm mb-4 text-gray-600">
                      There is no data available for the selected selected period.
                    </div>
                  </div>
                  
                  <br /><br /><br /><br /><br />
                </div>

                <div v-else>
                  <div style="float: left;">
                    <div class="stats-box-number" style="font-size: 34px;">{{ dashboard_data.reviews_stats.rating || 0.0 }}</div>
                  </div>

                  <div style="float: left; padding-left: 10px;">
                    <v-rating
                      class="-mt-1 -ml-1"
                      :value="(parseFloat(dashboard_data.reviews_stats.rating) || 0.0)"
                      :color="'orange ligten-1'"
                      dense
                      half-increments
                      readonly
                      size="24"
                    ></v-rating>
                    
                    <div class="text-xs pt-1 pb-4" style="color: #757575;">
                      Based on

                      <span class="mr-1">{{ dashboard_data.reviews_stats.reviews || 0 }}</span>

                      <span class="text-gray-600" v-show="100 == 1">Review</span>
                      <span class="text-gray-600" v-show="100 != 1">Reviews</span>
                    </div>
                  </div>

                  <div class="clearfix"></div>

                  <div class="w-full">
                    <div style="padding-right: 10px; clear: both; height: 16px; margin-top: 5px; color: #19233A; font-size: 12px;">
                      <div style="float: left; width: 40px;">
                        <i class="fa fa-star" style="color: #FFB443;"></i>&nbsp; 5
                      </div>
                      <div style="float: left; width: calc(100% - 70px); padding-top: 6px;">
                        <v-progress-linear
                          rounded
                          :value="(dashboard_data.reviews_stats.five_star_reviews/dashboard_data.reviews_stats.reviews) * 100"
                          color="#324E99"
                          background-color="grey lighten-4" 
                          height="6"
                        ></v-progress-linear>
                      </div>
                      <div style="float: right; margin-top: -1px;">
                        {{ dashboard_data.reviews_stats.five_star_reviews }}
                      </div>
                    </div>

                    <div style="padding-right: 10px; clear: both; height: 16px; margin-top: 15px; color: #19233A; font-size: 12px;">
                      <div style="float: left; width: 40px;">
                        <i class="fa fa-star" style="color: #FFB443;"></i>&nbsp; 4
                      </div>
                      <div style="float: left; width: calc(100% - 70px); padding-top: 6px;">
                        <v-progress-linear
                          rounded
                          :value="(dashboard_data.reviews_stats.four_star_reviews/dashboard_data.reviews_stats.reviews) * 100"
                          color="#324E99"
                          background-color="grey lighten-4"
                          height="6"
                        ></v-progress-linear>
                      </div>
                      <div style="float: right; margin-top: -1px;">
                        {{ dashboard_data.reviews_stats.four_star_reviews }}
                      </div>
                    </div>

                    <div style="padding-right: 10px; clear: both; height: 16px; margin-top: 15px; color: #19233A; font-size: 12px;">
                      <div style="float: left; width: 40px;">
                        <i class="fa fa-star" style="color: #FFB443;"></i>&nbsp; 3
                      </div>
                      <div style="float: left; width: calc(100% - 70px); padding-top: 6px;">
                        <v-progress-linear
                          rounded
                          :value="(dashboard_data.reviews_stats.three_star_reviews/dashboard_data.reviews_stats.reviews) * 100"
                          color="#324E99"
                          background-color="grey lighten-4"
                          height="6"
                        ></v-progress-linear>
                      </div>
                      <div style="float: right; margin-top: -1px;">
                        {{ dashboard_data.reviews_stats.three_star_reviews }}
                      </div>
                    </div>

                    <div style="padding-right: 10px; clear: both; height: 16px; margin-top: 15px; color: #19233A; font-size: 12px;">
                      <div style="float: left; width: 40px;">
                        <i class="fa fa-star" style="color: #FFB443;"></i>&nbsp; 2
                      </div>
                      <div style="float: left; width: calc(100% - 70px); padding-top: 6px;">
                        <v-progress-linear
                          rounded
                          :value="(dashboard_data.reviews_stats.two_star_reviews/dashboard_data.reviews_stats.reviews) * 100"
                          color="#324E99"
                          background-color="grey lighten-4"
                          height="6"
                        ></v-progress-linear>
                      </div>
                      <div style="float: right; margin-top: -1px;">
                        {{ dashboard_data.reviews_stats.two_star_reviews }}
                      </div>
                    </div>

                    <div class="mb-2" style="padding-right: 10px; clear: both; height: 16px; margin-top: 10px; color: #19233A; font-size: 12px;">
                      <div style="float: left; width: 40px;">
                        <i class="fa fa-star" style="color: #FFB443;"></i>&nbsp; 1
                      </div>
                      <div style="float: left; width: calc(100% - 70px); padding-top: 6px;">
                        <v-progress-linear
                          rounded
                          :value="(dashboard_data.reviews_stats.one_star_reviews/dashboard_data.reviews_stats.reviews) * 100"
                          color="#324E99"
                          background-color="grey lighten-4"
                          height="6"
                        ></v-progress-linear>
                      </div>
                      <div style="float: right; margin-top: -1px;">
                        {{ dashboard_data.reviews_stats.one_star_reviews }}
                      </div>
                    </div>
                  </div>

                  <iframe v-if="reviewsScoreData" style="width: 100%; margin-top: 20px;" height="200" :src="'https://review-frequency-tracker-720.created.app?embed=true&reviews=' + reviewsScoreData" title="Review Frequency Tracker" frameBorder="0"></iframe>
                </div>

              </div>
            </v-card>
          </div>
        </div>
      </div>

      <div class="-mx-2">
        <div class="flex flex-row flex-wrap mb-1 mt-1">
            <div class="dashboard-box stats-box w-full mb-3 px-2">
              <v-card class="pa-2" tile style="background: #4E7FC5;">
                <div class="details-box pl-3 pt-3 pb-3" style="color: #FFFFFF; font-weight: bold;">LSA Ad Spend</div>
              </v-card>
            </div>
        </div>
      </div>

      <div class="-mx-2">
        <div class="flex flex-row flex-wrap">
            <div class="dashboard-box stats-box w-full px-2 mb-3 px-2">
              <v-card class="pa-2" tile>
                  <div class="p-3" style="width: 100%; overflow-x: scroll;">

                    <table class="financial-table">
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>Gross Ad Spent</th>
                          <th>Net Ad Spent</th>
                          <th>Cost per Lead</th>
                          <th>Credits</th>
                          <th>Converted Lead Value</th>
                          <th>ROI</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in dashboard_data.rates.spend_by_month_table" :key="index">
                          <td>{{ item.month }}</td>
                          <td>${{ item.adspend }}</td>
                          <td>${{ item.adspend_net }}</td>
                          <td>${{ item.cost_per_lead }}</td>
                          <td>${{ item.credits }}</td>
                          <td>${{ item.converted_leads_amount }}</td>
                          <td>{{ item.roi }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="pt-2">
                      <apexchart
                        :options="chartThreeOptions"
                        :series="chartThreeSeries"
                        type="line"
                        height="300"
                      />
                    </div>
                  </div>
              </v-card>
            </div>
        </div>
      </div>

      <div v-show="me && (me.id == 1303 || me.id == 1304 || me.id == 966 || me.id == 1312 || me.id == 1222 || me.id == 964 || me.id == 1036)">
        <div v-show="me && (me.id == 1303 || me.id == 1304)" class="-mx-2">
          <div class="flex flex-row flex-wrap mb-1 mt-1">
              <div class="dashboard-box stats-box w-full mb-3 px-2">
                <v-card class="pa-2" tile style="background: #4E7FC5;">
                  <div class="details-box pl-3 pt-3 pb-3" style="color: #FFFFFF; font-weight: bold;">Credits and Ratings</div>
                </v-card>
              </div>
          </div>
        </div>

        <div v-show="me && (me.id == 1303 || me.id == 1304)" class="-mx-2">
          <div class="flex flex-row flex-wrap">
              <div class="dashboard-box stats-box w-full px-2 mb-3 px-2">
                <v-card class="pa-2" tile>
                    <div class="p-3" style="width: 100%; overflow-x: scroll;">

                      <table class="financial-table two">
                        <thead>
                          <tr>
                            <th>Credit Status</th>
                            <th>Total Leads</th>
                            <th>Phone</th>
                            <th>Message</th>
                            <th>Booking Leads</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in dashboard_data.credits_ratings_table.rows" :key="index">
                            <td>{{ item.status }}</td>
                            <td>{{ item.total }}</td>
                            <td>{{ item.phone }}</td>
                            <td>{{ item.message }}</td>
                            <td>{{ item.booking }}</td>
                          </tr>

                          <tr>
                            <th>Total</th>
                            <th>{{ dashboard_data.credits_ratings_table.totals.total }}</th>
                            <th>{{ dashboard_data.credits_ratings_table.totals.phone }}</th>
                            <th>{{ dashboard_data.credits_ratings_table.totals.message }}</th>
                            <th>{{ dashboard_data.credits_ratings_table.totals.booking }}</th>
                          </tr>
                        </tbody>
                      </table>

                      <div class="flex flex-row flex-wrap mb-1 mt-5">
                        <div class="dashboard-box stats-box w-full mb-4 md:w-1/2 lg:w-1/2">
                          <div style="max-width: 480px; margin: auto;">
                            <apexchart
                              :options="creditStatusPieOptions"
                              :series="creditStatusPieSeries"
                              type="pie"
                              width="540"
                            />
                          </div>
                        </div>

                        <div class="dashboard-box stats-box w-full mb-4 md:w-1/2 lg:w-1/2">
                          <div style="max-width: 480px; margin: auto;">
                            <apexchart
                              :options="creditStatusPieOptions2"
                              :series="creditStatusPieSeries2"
                              type="pie"
                              width="600"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                </v-card>
              </div>
          </div>
        </div>

        <div class="-mx-2">
          <div class="flex flex-row flex-wrap mb-1 mt-5">
            <div class="dashboard-box stats-box w-full mb-4">
              <div class="flex flex-row flex-wrap mb-1 mt-1">
                  <div class="dashboard-box stats-box w-full mb-3 px-2">
                    <v-card class="pa-2" tile style="background: #4E7FC5;">
                      <div class="details-box pl-3 pt-3 pb-3" style="color: #FFFFFF; font-weight: bold;">Calls Distribution</div>
                    </v-card>
                  </div>
              </div>
            </div>

            <div class="dashboard-box stats-box w-full mb-4">
              <div class="flex flex-wrap">
                <!-- Top Row: Distribution Bar, Donut, and OBH vs DBH -->
                <div class="w-full md:w-1/3 px-2 mb-4">
                  <v-card class="pa-3">
                    <apexchart type="bar" height="300" :options="callsBarOptions" :series="callsBarSeries" />
                  </v-card>
                </div>

                <div class="w-full md:w-1/3 px-2 mb-4">
                  <!-- Remove percentage heights/widths on <apexchart> -->
                  <v-card class="pa-3 d-flex align-center justify-center" style="height: 340px;">
                    <div style="width: 100%; max-width: 500px;">
                      <apexchart
                        type="donut"
                        height="300"
                        width="100%"
                        :options="callsPieOptions"
                        :series="callsPieSeries"
                      />
                    </div>
                  </v-card>
                </div>

                <div class="w-full md:w-1/3 px-2 mb-4">
                  <v-card class="pa-3">
                    <apexchart type="bar" height="300" :options="dbhObhOptions" :series="dbhObhSeries" />
                  </v-card>
                </div>

                <!-- Bottom Row: Daily Trends Line Chart -->
                <div class="w-full px-2 mb-4">
                  <v-card class="pa-3">
                    <apexchart type="line" height="350" :options="dailyLineOptions" :series="dailyLineSeries" />
                  </v-card>
                </div>
                <div v-if="dashboard_data.hourly_missed_opportunities" class="w-full px-2 mb-4">
                  <v-card class="pa-3">
                    <h3 class="font-weight-bold">Missed Opportunities by Hour</h3>
                    <apexchart type="bar" height="350" :options="hourlyMoOptions" :series="hourlyMoSeries" />
                    <div style="overflow-x: auto;">
                      <table class="financial-table two">
                        <thead>
                          <tr><th>Time</th><th>Aba 8-</th><th>Aba 8+</th><th>MC</th><th>VM</th><th>Total Calls</th><th>Total MOs</th><th>% MOs</th></tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in activeHourlyMoRows" :key="row.hour">
                            <td>{{ row.time }}</td><td>{{ row['Aba 8-'] }}</td><td>{{ row['Aba 8+'] }}</td><td>{{ row.MC }}</td><td>{{ row.VM }}</td>
                            <td>{{ row.total_calls }}</td><td>{{ row.total_mos }}</td><td>{{ row.percentage.toFixed(2) }}%</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="font-weight-bold">
                            <td>Total</td>
                            <td v-for="key in ['Aba 8-', 'Aba 8+', 'MC', 'VM', 'total_calls', 'total_mos']" :key="key">{{ dashboard_data.hourly_missed_opportunities.totals[key] }}</td>
                            <td>{{ dashboard_data.hourly_missed_opportunities.totals.percentage.toFixed(2) }}%</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    <p class="mt-2">% MOs = missed opportunities in that hour ÷ total calls in the selected period.</p>
                  </v-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="me && (me.id == 1303 || me.id == 1304)" class="-mx-2">
          <div class="flex flex-row flex-wrap mb-1 mt-1">
              <div class="dashboard-box stats-box w-full mb-3 px-2">
                <v-card class="pa-2" tile style="background: #4E7FC5;">
                  <div class="details-box pl-3 pt-3 pb-3" style="color: #FFFFFF; font-weight: bold;">Qualified Leads</div>
                </v-card>
              </div>
          </div>
        </div>

        <div v-show="me && (me.id == 1303 || me.id == 1304)" class="-mx-2">
          <div class="flex flex-row flex-wrap">
              <div class="dashboard-box stats-box w-full px-2 mb-3 px-2">
                <v-card class="pa-2" tile>
                    <div class="p-3" style="width: 100%; overflow-x: scroll;">

                      <table class="financial-table two">
                        <thead>
                          <tr>
                            <th>Qualified But?</th>
                            <th>Total Leads</th>
                            <th>Charged Leads</th>
                            <th>Phone</th>
                            <th>Message</th>
                            <th>Booking</th>
                            <th>Credits</th>
                            <th>Percentage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in dashboard_data.qualified_leads_table.rows" :key="index">
                            <td>{{ item.status }}</td>
                            <td>{{ item.total }}</td>
                            <td>{{ item.charged }}</td>
                            <td>{{ item.phone }}</td>
                            <td>{{ item.message }}</td>
                            <td>{{ item.booking }}</td>
                            <td>{{ item.credits }}</td>
                            <td>{{ item.percentage.toFixed(2) }}%</td>
                          </tr>

                          <tr>
                            <th>Total</th>
                            <th>{{ dashboard_data.qualified_leads_table.totals.total }}</th>
                            <th>{{ dashboard_data.qualified_leads_table.totals.credits }}</th>
                            <th>{{ dashboard_data.qualified_leads_table.totals.phone }}</th>
                            <th>{{ dashboard_data.qualified_leads_table.totals.message }}</th>
                            <th>{{ dashboard_data.qualified_leads_table.totals.booking }}</th>
                            <th>{{ dashboard_data.qualified_leads_table.totals.credits }}</th>
                            <th>{{ dashboard_data.qualified_leads_table.totals.percentage.toFixed(2) }}%</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                </v-card>
              </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapState} from "vuex";
import PanelNavigation from "@/components/PanelNavigation.vue";
// import Map from "@/assets/map.png";
import ApexCharts from "apexcharts";
import VueApexCharts from "vue-apexcharts";
import moment from 'moment'

// Color Palette (Answered, Aba 8-, Aba 8+, MC, VM)
const chartColors = ["#3366CC", "#F4C744", "#E67E22", "#E74C3C", "#C0392B"];

export default {
  metaInfo() {
      return {
          title: "Dashboard | " + this.$appName,
      };
  },
  components: {
      apexchart: VueApexCharts,
      PanelNavigation,
  },
  data() {
      return {
          selected_frequency: 'Monthly',

          show_picker: false,
          date_filter: [
            moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD'),
            moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
          ],

          all_time: 0,

          selected_date_text: "Last 6 months",

          tags_selected: [],

          custom_tags_colors: {},

          toggle: false,
          chartOneOptions: {
              colors: ["#4E7FC5","rgb(255, 69, 96)"],
              chart: {
                  id: "column-chart",
                  toolbar: {
                      show: false
                  }
              },
              legend: {
                  position: 'top',
                  horizontalAlign: 'right',
                  markers: {
                    width: 8,
                    height: 8,
                    strokeWidth: 0,
                    strokeColor: '#fff',
                    fillColors: undefined,
                    radius: 8,
                    customHTML: undefined,
                    onClick: undefined,
                    offsetX: 0,
                    offsetY: 0
                },
              },
              dataLabels: {
                  enabled: false
              },
              stroke: {
                  curve: "smooth", // Set the curve property to 'smooth'
              },
              xaxis: {
                  categories: ["August", "September", "October", "November"],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: {
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              plotOptions: {
                  bar: {
                      columnWidth: "20%", // Adjust the column width to make the bars thinner
                  },
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },
          },
          chartOneSeries: [

              {
                  name: 'Approved Credits',
                  data: [10, 20, 30, 40], // Custom values for y-axis
              },
              {
                  name: 'Charged Leads',
                  data: [10, 20, 30, 40], // Custom values for y-axis
              },
          ],

          chartTwoOptions: {
              colors: ["#4E7FC5", "rgb(255, 69, 96)"],
              chart: {
                  id: "column-chart",
                  toolbar: {
                      show: false
                  }
              },
              legend: {
                  position: 'top',
                  horizontalAlign: 'right',
                  showForSingleSeries: true,
                  showForNullSeries: true,
                  showForZeroSeries: true,
                  markers: {
                    width: 8,
                    height: 8,
                    strokeWidth: 0,
                    strokeColor: '#fff',
                    fillColors: undefined,
                    radius: 8,
                    customHTML: undefined,
                    onClick: undefined,
                    offsetX: 0,
                    offsetY: 0
                },
              },
              dataLabels: {
                  enabled: false
              },
              xaxis: {
                  categories: ["August", "September", "October", "November"],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: {
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              plotOptions: {
                  bar: {
                      columnWidth: "10%", // Adjust the column width to make the bars thinner
                  },
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },
          },
          chartTwoSeries: [
              {
                  name: 'Leads',
                  data: [10, 20, 30, 40], // Custom values for y-axis
              },
          ],

          chartThreeOptions: {

              colors: ["#025ede", "#40c0e3", "#ff7300", "#9b59b6", "#2f9e44", "#006400"],

              chart: {
                  id: "column-chart",
                  toolbar: {
                      show: false
                  }
              },

              xaxis: {
                  categories: ["August", "September", "October", "November"],
              },

              yaxis: [
                {
                  opposite: false,
                  show: true,
                },
                {
                  opposite: false,
                  show: false,
                },
                {
                  opposite: false,
                  show: false,
                },
                {
                  opposite: false,
                  show: false,
                },
                {
                  opposite: false,
                  show: false,
                },
                {
                  opposite: true,
                  show: true,
                  min: -1,
                  labels: {
                    formatter: function(value) {
                      if (value == -1) {
                        return value.toFixed(2) + '+';
                      } else {
                        return value;
                      }
                    }
                  }
                }
              ],

              plotOptions: {
                bar: {
                  dataLabels: {
                    position: 'top' // or 'bottom' if horizontal
                  },
                  barHeight: '70%', // optional visual tweak
                  horizontal: false, // or true if it's a horizontal chart
                  startingShape: 'flat',
                  endingShape: 'flat'
                }
              },
              dataLabels: {
                  enabled: false
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },
              stroke: {
                width: [0, 0,  0,  0,  0, 3] // Assuming the line is the third series
              },
              markers: {
                size: [0, 0,  0,  0,  0, 4],         // 0 for bars, 8px for line dots
                strokeWidth: [0, 0,  0,  0,  0, 4],  // 4px border around the line dots
                strokeColors: ['transparent', 'transparent', 'transparent', 'transparent', 'transparent', '#006400'], // black border for line markers
                colors: ['transparent', 'transparent', 'transparent', 'transparent', 'transparent', '#006400'],    // fill color for line markers
                shape: 'circle',
                hover: {
                  sizeOffset: 2
                }
              },
              tooltip: {
                x: {
                  show: false
                },
                y: {
                  formatter: function(value, series) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  }
                }
              }
          },

          chartThreeSeries: [
              {
                  name: 'Cost',
                  data: [10, 20, 30, 40, 50, 60], // Custom values for y-axis
              },
          ],

          lineChartOptions: {
              colors: ["rgb(0, 143, 251)", "rgb(0, 227, 150)", "rgb(254, 176, 25)", "rgb(119, 93, 208)", "rgb(255, 69, 96)"],
              chart: {
                  id: "performanceChart",
                  toolbar: {
                      show: false
                  }
              },
              xaxis: {
                  categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                  ],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis:
                [
                {
                  opposite: false,
                  show: false,
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
                },
                {
                  opposite: false,
                  // show: false,
                  min: 0,
                  max: 100,
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
                },
                {
                  opposite: false,
                  show: false,
                  min: 0,
                  max: 100,
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
                },
                {
                  opposite: false,
                  show: false,
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
                },
                {
                  opposite: true,
                  // show: false,
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
                }
                ]
              ,
              stroke: {
                  curve: "smooth", // Set the curve property to 'smooth'
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },

              tooltip: {
                shared: true,
                intersect: false,
                y: [{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + y + " Hours";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y) + " Leads";
                  }
                }]
              }
          },
          lineChartSeries: [
              {
                name: "Reviews",
                data: [30, 40, 25, 50, 49],
              },
          ],

          lineChartLeadVolumeOptions: {
              colors: ["rgb(255, 69, 96)","rgb(0, 227, 150)", "rgb(119, 93, 208)"],
              chart: {
                  id: "leadVolumeChart",
                  toolbar: {
                      show: false
                  }
              },
              xaxis: {
                  categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                  ],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              stroke: {
                  curve: "smooth", // Set the curve property to 'smooth'
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },

              tooltip: {
                shared: true,
                intersect: false,
                y: [{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }]
              }
          },
          lineChartLeadVolumeSeries: [
              {
                name: "Total Leads",
                data: [30, 40, 25, 50, 49],
              },
          ],

          lineChartMetricsOptions: {
              colors: ["rgb(0, 143, 251)", "rgb(0, 227, 150)", "rgb(254, 176, 25)", "rgb(255, 69, 96)", "rgb(119, 93, 208)", "#4284C1"],
              chart: {
                  id: "line-chart",
                  toolbar: {
                      show: false
                  }
              },
              xaxis: {
                  categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                  ],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: [
                {
                  opposite: false,
                  labels: {
                    show: true
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                }
              ],
              stroke: {
                  curve: "smooth", // Set the curve property to 'smooth'
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },

              tooltip: {
                shared: true,
                intersect: false,
                y: [{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": $" + y;
                  }
                }]
              }
          },
          lineChartMetricsSeries: [
              {
                name: "Reviews",
                data: [30, 40, 25, 50, 49, 49],
              },
          ],

          lineChartCallMessageMetricsOptions: {
            chart: {
                height: 350,
                type: 'bubble',
                toolbar: {
                  show: false
                }
            },
            dataLabels: {
                enabled: true
            },
            fill: {
                opacity: 0.8
            },
            title: {
                text: 'Simple Bubble Chart'
            },
            legend: {
              show: false
            },
            xaxis: {
                tickAmount: 12,
                type: 'category',
                labels: {
                  show: false,
                }
            },
            yaxis: {
                labels: {
                  show: false,
                }
            }
          },
          lineChartCallMessageMetricsSeries: [{
            name: 'Tag1',
            data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          },
          {
            name: 'Tag2',
            data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          },
          {
            name: 'Tag3',
            data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          },
          {
            name: 'Tag4',
            data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          }],

          Map: Map,
          fieldsOne: ["monthly", "aspend", "conversion"],
          itemsOne: [
              {
                  monthly: "August",
                  aspend: "$32,384.7",
                  conversion: "4.32%",
              },
              {
                  monthly: "August",
                  aspend: "$32,384.7",
                  conversion: "4.32%",
              },
              {
                  monthly: "August",
                  aspend: "$32,384.7",
                  conversion: "4.32%",
              },
          ],
          fieldsTwo: ["monthly", "average_cost_per_lead", "cost_per_customer"],
          itemsTwo: [
              {
                  monthly: "August",
                  average_cost_per_lead: "$32,384.7",
                  cost_per_customer: "4.32%",
              },
              {
                  monthly: "August",
                  average_cost_per_lead: "$32,384.7",
                  cost_per_customer: "4.32%",
              },
              {
                  monthly: "August",
                  average_cost_per_lead: "$32,384.7",
                  cost_per_customer: "4.32%",
              },
          ],

          loading: true,

          dashboard_data: [],
          dashboard_data_prev: [],
          comparisons: {},

          showBubbleChart: false,
          bubbleTags: null,

          reviewsScoreData: null,

          creditStatusPieSeries: [44, 55, 13, 43, 22],

          creditStatusPieOptions: {
            chart: { type: "pie", width: 540 },
            labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
            legend: { position: "right" },
            colors: [
              "#008FFB", // blue
              "#FEB019", // yellow
              "#CCCCCC", // gray
              // "#00E396", // green
              // "#775DD0", // purple
              // "#3F51B5", // indigo
              // "#546E7A", // blue gray
              // "#D4526E", // rose
              "#8D5B4C", // brown
              "#F86624"  // orange
            ]
          },

          creditStatusPieSeries2: [44, 55, 13, 43, 22],

          creditStatusPieOptions2: {
            chart: { type: "pie", width: 600 },
            labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
            legend: { position: "right" },
            colors: [
              // "#008FFB", // blue
              // "#FEB019", // yellow
              // "#CCCCCC", // gray
              "#00E396", // green
              "#775DD0", // purple
              "#3F51B5", // indigo
              "#546E7A", // blue gray
              "#D4526E", // rose
              // "#8D5B4C", // brown
              // "#F86624"  // orange
            ]
          },

          // 1. Calls Distribution Bar Chart
          callsBarOptions: {
            chart: { type: 'bar', toolbar: { show: false } },
            colors: chartColors,
            plotOptions: { bar: { columnWidth: '40%', distributed: true } },
            legend: { show: false },
            xaxis: { categories: ["Answered", "Aba 8-", "Aba 8+", "MC", "VM"] }
          },
          callsBarSeries: [{ name: 'Calls', data: [0, 0, 0, 0, 0] }],

          // 2. Calls Distribution Donut/Pie Chart
          callsPieOptions: {
            chart: {
              type: "donut",
              // Remove fixed height/width here to prevent conflict with template props
              redrawOnWindowResize: false // Prevents the window resize infinite loop
            },
            labels: ["Answered", "Aba 8-", "Aba 8+", "MC", "VM"],
            colors: ["#3366CC", "#F4C744", "#E67E22", "#E74C3C", "#C0392B"],
            legend: {
              position: "right"
            }
          },
          callsPieSeries: [0, 0, 0, 0, 0],

          // 3. OBH vs DBH Bar Chart
          dbhObhOptions: {
            chart: { type: 'bar', toolbar: { show: false } },
            colors: ["#3366CC", "#E74C3C", "#C0392B"],
            plotOptions: { bar: { columnWidth: '35%', distributed: true } },
            xaxis: { categories: ["Total Calls", "MO (DBH)", "MO (OBH)"] }
          },
          dbhObhSeries: [{ name: 'Count', data: [0, 0, 0] }],

          // 4. Daily Trends Line Chart
          dailyLineOptions: {
            chart: { type: 'line', curve: 'smooth', toolbar: { show: false } },
            colors: chartColors,
            stroke: { width: 3 },
            xaxis: { categories: [] },
            dataLabels: { enabled: true }
          },
          hourlyMoOptions: {
            chart: { type: 'bar', toolbar: { show: false } },
            colors: ['#3366CC', '#E74C3C'],
            plotOptions: { bar: { columnWidth: '65%' } },
            xaxis: { categories: [] },
            yaxis: { min: 0, decimalsInFloat: 0, title: { text: 'Number of calls' } },
            dataLabels: { enabled: false },
            legend: { position: 'bottom' }
          },
          hourlyMoSeries: [],
          moCallHeaders: [
            { text: 'Call ID', value: 'id' },
            { text: 'Exact Time (Client Timezone)', value: 'time', sortable: false },
            { text: 'Outcome', value: 'category' },
            { text: 'DBH / OBH', value: 'business_hours' }
          ],
          dailyLineSeries: []
        }
  },
  methods: {
      generateData(baseval, count, yrange, theValue) {
        var i = 0;
        var series = [];

        var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
        var y = theValue;
        var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

        series.push([x, y, z]);
        baseval += 86400000;
        i++;

        return series;
      },
      
      getLimit() {

        switch (tis.me.subscription.product_details.code) {
          case 'business_unlimited':
              return 100;
          break;

          case 'starter':
              return 500;
          break;

          case 'professional':
              return 30;
          break;

          case 'business_unlimited':
              return 250;
          break;
        }
      },

      limitOfWhat() {
        switch (this.me.subscription.product_details.code) {
          case 'business_unlimited':
              return 'conversations';
          break;

          case 'starter':
              return 'messages';
          break;

          case 'professional':
              return 'conversations';
          break;

          case 'business_unlimited':
              return 'conversations';
          break;
        }
      },

      formatDate: function(date, format = "MM/DD/YYYY") {
        return moment(String(date)).format(format)
      },

      numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },

      filterDate() {
        if (!this.date_filter[1])
            return;

        let diff_days = moment(this.date_filter[1]).diff(this.date_filter[0], 'days') + 1;

        if (diff_days <= 28) {
          this.selected_frequency = 'Frequency: Auto';
        }

        this.show_picker = false;
        this.selected_date_text = '';
        this.loadDashboard();
      },

      applyDate(selected_date) {
        this.all_time = 0;
        this.selected_date_text = selected_date;
        switch (selected_date) {
          case 'This Week':
            this.date_filter[0] = moment().startOf('week').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('week').format('YYYY-MM-DD');

            this.selected_frequency = 'Frequency: Auto';
          break;
          case 'Last Week':
            this.date_filter[0] = moment().startOf('week').subtract(7, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('week').subtract(7, 'days').format('YYYY-MM-DD');

            this.selected_frequency = 'Frequency: Auto';
          break;
          case 'This Month':
            this.date_filter[0] = moment().startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('month').format('YYYY-MM-DD');

            this.selected_frequency = 'Frequency: Auto';
          break;
          case 'Last Month':
            this.date_filter[0] = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last 30 days':
            this.date_filter[0] = moment().subtract(30, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');

            this.selected_frequency = 'Frequency: Auto';
          break;
          case 'Last 60 days':
            this.date_filter[0] = moment().subtract(60, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
          break;
          case 'Last 90 days':
            this.date_filter[0] = moment().subtract(90, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
          break;
          case 'This Year':
            this.date_filter[0] = moment().startOf('year').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('year').format('YYYY-MM-DD');
          break;
          case 'Last Year':
            this.date_filter[0] = moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD');
          break;

          case 'All Time':
            this.date_filter[0] = moment().startOf('year').subtract(10, 'years').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
            
            this.all_time = 1;
          break;

          case 'Last 6 months':
            this.date_filter[0] = moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last 12 months':
            this.date_filter[0] = moment().subtract(12, 'months').startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last 24 months':
            this.date_filter[0] = moment().subtract(24, 'months').startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last 36 months':
            this.date_filter[0] = moment().subtract(36, 'months').startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
          break;
        }
        this.show_picker = false;
        this.loadDashboard();
      },

      getCallMessageMetricsColors() {
        let colors = ["rgb(255, 69, 96)"];

        let defaultTagsColors = {
          "Not Set": "#e0e0e0",
          "Existing Customer": "#3EBB80",
          "Missed Call": "#44468F",
          "Opportunity": "#FFB443",
          "Meeting Scheduled": "#2477F6",
          "Became Customer": "#E53F71",
          "Signed": "#2137cb",
          "Booked for Consultation": "#2bce7f",
          "Declined/Not a lead": "#aa242b",
          "Wrong Number": "#de2f4d",
          "No Response": "#3f3f3f",
          "Existing Client": "#4ad25a",
          "Failed Sign Up": "#830934",
          "Following Up/Working on this one": "#9418af",
          "E-Doc sent not signed": "#5a3a69",
          "Booked to Service": "#2bce7f",
          "Booked for Appointment": "#1921ba",
          "Cancelled": "#c6ab24"
        };


        for (var i in this.tags_selected) {
           let thisColor = "";

           try {
            thisColor = defaultTagsColors[this.tags_selected[i].text];
           }
           catch (e) {}

          if (!thisColor) {
           try {
            thisColor = this.custom_tags_colors[this.tags_selected[i].text];
           }
           catch (e) {}
          }

           if (thisColor)
            colors.push(thisColor); 
        }

        return colors;
      },

      async loadCustomTags() {
        let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/load-custom-tags`, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.custom_tags = response.data.custom_tags;

        this.tags_items = [{
            index: 0,
            text: 'Not Set'
        },{
            index: 1,
            text: 'Existing Customer'
        },{
            index: 2,
            text: 'Missed Call'
        },{
            index: 3,
            text: 'Opportunity'
        },{
            index: 4,
            text: 'Meeting Scheduled'
        },{
            index: 5,
            text: 'Became Customer'
        },{
            index: 'Signed',
            text: 'Signed'
        }
        ,{
            index: 'Booked for Consultation',
            text: 'Booked for Consultation'
        }
        ,{
            index: 'Declined/Not a lead',
            text: 'Declined/Not a lead'
        }
        ,{
            index: 'Wrong Number',
            text: 'Wrong Number'
        }
        ,{
            index: 'No Response',
            text: 'No Response'
        }
        ,{
            index: 'Existing Client',
            text: 'Existing Client'
        }
        ,{
            index: 'Failed Sign Up',
            text: 'Failed Sign Up'
        }
        ,{
            index: 'Following Up/Working on this one',
            text: 'Following Up/Working on this one'
        }
        ,{
            index: 'E-Doc sent not signed',
            text: 'E-Doc sent not signed'
        }
        ,{
            index: 'Booked to Service',
            text: 'Booked to Service'
        }
        ,{
            index: 'Booked for Appointment',
            text: 'Booked for Appointment'
        }
        ,{
            index: 'Cancelled',
            text: 'Cancelled'
        }
        ]

        // --- FIX APPLIED HERE ---
        for (var i in this.custom_tags) {
            let rawTag = this.custom_tags[i].tag;
            
            // Convert any actual checkmark symbol into a browser-safe HTML entity code
            let safeTag = rawTag.replace(/✓/g, '').replace(/\(\s*\)/g, '').trim();

            this.tags_items.push({
                index: this.custom_tags[i].tag, // Keep the raw string value for the backend value
                text: safeTag                   // Use the entity code for visual display
            });

            this.custom_tags_colors[this.custom_tags[i].tag] = this.custom_tags[i].color;
        }

        this.tags_selected = JSON.parse(JSON.stringify(this.tags_items));
    },

    // Add this helper method right below or alongside your loadCustomTags method
    fixEncoding(str) {
        if (!str) return '';
        try {
            // Method A: Fixes standard ISO-8859-1 to UTF-8 translation issues in JS strings
            return decodeURIComponent(escape(str));
        } catch (e) {
            // Method B Fallback: Directly replaces the corrupted checkmark string if Method A fails
            return str.replace(/âžœ/g, '➜').replace(/âœ“/g, '✓');
        }
    },

      async loadDashboard() {
        this.loading = true;

        if (!this.selected_tags)
          await this.loadCustomTags();

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data`, {
            start_date: this.date_filter[0],
            end_date: this.date_filter[1],
            all_time: this.all_time,
            selected_frequency: this.selected_frequency,
            tags_selected: JSON.stringify(this.tags_selected)
          },
          {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          }
        );

        this.dashboard_data = response.data.dashboard_data;


        this.chartOneOptions.xaxis.categories = this.dashboard_data.disputes_chart.labels;

        this.chartOneSeries = [
          {
            name: 'Approved Credits',
            data: this.dashboard_data.disputes_chart.datasets['Approved Disputes']
          },
          {
            name: 'Charged Leads',
            data: this.dashboard_data.disputes_chart.datasets['Charged Leads']
          }
        ];

        this.chartTwoOptions.xaxis.categories = this.dashboard_data.leads_chart.labels;

        this.chartTwoSeries = [
          {
            name: 'Total Leads',
            data: this.dashboard_data.leads_chart.datasets['Leads']
          },
          {
            name: 'Not Charged',
            data: this.dashboard_data.leads_chart.datasets['Not Charged']
          }
        ];

        this.lineChartOptions.xaxis.categories = this.dashboard_data.performance_chart.labels;

        this.lineChartSeries = [
          {
            name: 'Reviews',
            data: this.dashboard_data.performance_chart.datasets['Reviews']
          },
          {
            name: 'Response Rate',
            data: this.dashboard_data.performance_chart.datasets['Response Rate']
          },
          {
            name: 'Under 30 seconds Call Response Rate',
            data: this.dashboard_data.performance_chart.datasets['Under 30s Response Rate']
          },
          {
            name: 'Message Response Time',
            data: this.dashboard_data.performance_chart.datasets['Messages Response Time']
          },
          {
            name: 'Lead Volume',
            data: this.dashboard_data.performance_chart.datasets['Lead Volume']
          }
        ];

        this.lineChartLeadVolumeOptions.xaxis.categories = this.dashboard_data.lead_volume_chart.labels;

        this.lineChartLeadVolumeSeries = [
          {
            name: 'Total Leads',
            data: this.dashboard_data.lead_volume_chart.datasets['Total Leads']
          },
          {
            name: 'Phone Leads',
            data: this.dashboard_data.lead_volume_chart.datasets['Phone Leads']
          },
          {
            name: 'Message Leads',
            data: this.dashboard_data.lead_volume_chart.datasets['Message Leads']
          }
        ];

        setTimeout(function() {
          const chart = ApexCharts.getChartByID('performanceChart')
          chart.hideSeries('Voice Under 30s Response Rate');
        }, 500);

        this.lineChartMetricsOptions.xaxis.categories = this.dashboard_data.metrics_chart.labels;

        this.lineChartMetricsSeries = [
          {
            name: 'Impressions',
            data: this.dashboard_data.metrics_chart.datasets['Impressions']
          },
          {
            name: 'Top Impressions Rate',
            data: this.dashboard_data.metrics_chart.datasets['Top Impressions']
          },
          {
            name: 'Absolute Top Impressions Rate',
            data: this.dashboard_data.metrics_chart.datasets['Absolute Top Impressions']
          },
          {
            name: 'Lead Volume',
            data: this.dashboard_data.metrics_chart.datasets['Lead Volume']
          },
          {
            name: 'Clicks',
            data: this.dashboard_data.metrics_chart.datasets['Clicks']
          },
          {
            name: 'Total Cost',
            data: this.dashboard_data.metrics_chart.datasets['Cost']
          }
        ];

        this.lineChartCallMessageMetricsOptions.colors = this.getCallMessageMetricsColors();
        this.lineChartCallMessageMetricsOptions.xaxis.categories = this.dashboard_data.metrics_chart.labels;

        let theTags = [];

        for (var i in this.dashboard_data.tags_chart_data) {
          if (i == "Not Set" || i == "Lead Volume")
            continue;

          theTags.push({
            tag: i,
            count: this.dashboard_data.tags_chart_data[i]
          })
        }

        this.showBubbleChart = true;

        function shuffleArr(array) {
          let currentIndex = array.length;

          // While there remain elements to shuffle...
          while (currentIndex != 0) {

            // Pick a remaining element...
            let randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
              array[randomIndex], array[currentIndex]];
          }
        }

        function toBinaryStr(str) {
          const encoder = new TextEncoder();
          // 1: split the UTF-16 string into an array of bytes
          const charCodes = encoder.encode(str);
          // 2: concatenate byte data to create a binary string
          return String.fromCharCode(...charCodes);
        }

        shuffleArr(theTags);

        this.bubbleTags = btoa(toBinaryStr(JSON.stringify(theTags)));

        this.chartThreeOptions.xaxis.categories = this.dashboard_data.rates.spend_by_month_chart.labels;

        this.chartThreeSeries = [
          {
            name: 'Gross Ad Spent',
            data: this.dashboard_data.rates.spend_by_month_chart.datasets['Gross Ad Spent'],
            type: 'column',
          },
          {
            name: 'Net Ad Spent',
            data: this.dashboard_data.rates.spend_by_month_chart.datasets['Net Ad Spent'],
            type: 'column',
          },
          {
            name: 'Cost per Lead',
            data: this.dashboard_data.rates.spend_by_month_chart.datasets['Cost per Lead'],
            type: 'column',
          },
          {
            name: 'Credits',
            data: this.dashboard_data.rates.spend_by_month_chart.datasets['Credits'],
            type: 'column',
          },
          {
            name: 'Converted Lead Value',
            data: this.dashboard_data.rates.spend_by_month_chart.datasets['Converted Lead Value'],
            type: 'column',
          },
          {
            name: 'ROI',
            data: this.dashboard_data.rates.spend_by_month_chart.datasets['ROI'],
            type: 'line',
          }
        ];

        console.log('this.chartThreeSeries', this.chartThreeSeries);

        this.creditStatusPieSeries = [];
        this.creditStatusPieOptions.labels = [];

        for (var i in this.dashboard_data.credits_ratings_table.rows) {
          if (this.dashboard_data.credits_ratings_table.rows[i].status == 'Auto Credited' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Rated-Approved' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Rated' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Rated-Not Charged' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Not Rated-Archived') {

              this.creditStatusPieSeries.push(this.dashboard_data.credits_ratings_table.rows[i].total);
              this.creditStatusPieOptions.labels.push(this.dashboard_data.credits_ratings_table.rows[i].status);
          }
        }

        this.creditStatusPieSeries2 = [];
        this.creditStatusPieOptions2.labels = [];

        for (var i in this.dashboard_data.credits_ratings_table.rows) {
          if (this.dashboard_data.credits_ratings_table.rows[i].status == 'Very Satisfied' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Somewhat satisfied' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Neither satisfied nor dissatisfied' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Somewhat dissatisfied' || 
            this.dashboard_data.credits_ratings_table.rows[i].status == 'Very dissatisfied') {

              this.creditStatusPieSeries2.push(this.dashboard_data.credits_ratings_table.rows[i].total);
              this.creditStatusPieOptions2.labels.push(this.dashboard_data.credits_ratings_table.rows[i].status);
          }
        }

        // Inside API response handler:
        const dist = this.dashboard_data.calls_distribution_table;
        const counts = [dist["Answered"], dist["Aba 8-"], dist["Aba 8+"], dist["MC"], dist["VM"]];

        // Update Bar Chart
        this.callsBarSeries = [{ name: 'Calls', data: counts }];

        // Update Pie Chart
        this.callsPieSeries = counts;

        // Update OBH/DBH
        const obh = this.dashboard_data.obh_dbh_table;
        this.dbhObhSeries = [{ name: 'Calls', data: [obh["Total"], obh["MO (DBH)"], obh["MO (OBH)"]] }];

        const hourly = this.dashboard_data.hourly_missed_opportunities;
        const hourlyRows = hourly ? hourly.rows : [];
        this.hourlyMoOptions = {
          ...this.hourlyMoOptions,
          xaxis: { categories: hourlyRows.map(row => row.time) }
        };
        this.hourlyMoSeries = [
          { name: 'Total Calls', data: hourlyRows.map(row => row.total_calls) },
          { name: 'Total MOs', data: hourlyRows.map(row => row.total_mos) }
        ];

        // Update Daily Line Chart
        const dailyData = this.dashboard_data.daily_trends;
        const dates = Object.keys(dailyData);

        this.dailyLineOptions.xaxis.categories = dates;
        this.dailyLineSeries = [
          { name: 'Answered', data: dates.map(d => dailyData[d]['Answered']) },
          { name: 'Aba 8-',   data: dates.map(d => dailyData[d]['Aba 8-']) },
          { name: 'Aba 8+',   data: dates.map(d => dailyData[d]['Aba 8+']) },
          { name: 'MC',       data: dates.map(d => dailyData[d]['MC']) },
          { name: 'VM',       data: dates.map(d => dailyData[d]['VM']) },
        ];

        let diff_days = moment(this.date_filter[1]).diff(this.date_filter[0], 'days') + 1;


        let date_prev_start = moment(this.date_filter[0]).subtract(diff_days, 'days').format('YYYY-MM-DD');
        let date_prev_end = moment(this.date_filter[1]).subtract(diff_days, 'days').format('YYYY-MM-DD');

        if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency != 'Frequency: Auto') {
          date_prev_start = moment(this.date_filter[0]).subtract(1, 'months').format('YYYY-MM-DD');
          date_prev_end = moment(date_prev_start).endOf('month').format('YYYY-MM-DD');
        }

        if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency == 'Frequency: Auto') {
          date_prev_start = moment(this.date_filter[0]).subtract(1, 'months').format('YYYY-MM-DD');
          date_prev_end = moment(date_prev_start).add(1, 'months').format('YYYY-MM-DD');
        }

        function toBinaryStr(str) {
          const encoder = new TextEncoder();
          // 1: split the UTF-16 string into an array of bytes
          const charCodes = encoder.encode(str);
          // 2: concatenate byte data to create a binary string
          return String.fromCharCode(...charCodes);
        }

        this.reviewsScoreData = btoa(toBinaryStr(JSON.stringify(response.data.reviewsScoreData)));


        let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data`, {
            start_date: date_prev_start,
            end_date: date_prev_end,
            all_time: this.all_time,
            selected_frequency: this.selected_frequency,
            tags_selected: JSON.stringify(this.tags_selected)
          },
          {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          }
        );

        this.dashboard_data_prev = response2.data.dashboard_data;
        
        this.calculateComparisons();
        
        this.loading = false;
      },

      calculateComparison(data_now, data_previous) {
        data_now = parseFloat(data_now);
        data_previous = parseFloat(data_previous);

        if (data_now == 0 && data_previous == 0)
          return 0.00;

        if (data_now > 0 && data_previous == 0)
          return 100.00;

        if (data_now == 0 && data_previous > 0)
          return 100.00;

        let percentage;

        if (data_now > data_previous) {
          let x = (data_previous/data_now) * 100
          percentage = 100 - x;
        }
        else {
          let x = (data_now/data_previous) * 100
          percentage = 100 - x;
        }

        if (percentage <= 0)
          percentage = percentage * -1;

        percentage = percentage.toFixed(2);

        return percentage;
      },

      calculateComparisons() {
        // Charged Leads Total
        this.comparisons.charged_leads_total = this.calculateComparison(this.dashboard_data.charged_leads_total, this.dashboard_data_prev.charged_leads_total);
        // END Charged Leads Total


        // Charged Leads Calls
        this.comparisons.charged_leads_calls = this.calculateComparison(this.dashboard_data.charged_leads_calls, this.dashboard_data_prev.charged_leads_calls);
        // END Charged Leads Calls


        // Charged Leads Messages
        this.comparisons.charged_leads_messages = this.calculateComparison(this.dashboard_data.charged_leads_messages, this.dashboard_data_prev.charged_leads_messages);
        // END Charged Leads Messages


        // Charged Leads Bookings
        this.comparisons.charged_leads_bookings = this.calculateComparison(this.dashboard_data.charged_leads_bookings, this.dashboard_data_prev.charged_leads_bookings);
        // END Charged Leads Bookings


        // Total Leads
        this.comparisons.total_leads = this.calculateComparison(this.dashboard_data.total_leads, this.dashboard_data_prev.total_leads);
        // END Total Leads


        // Total Calls
        this.comparisons.total_calls = this.calculateComparison(this.dashboard_data.total_calls, this.dashboard_data_prev.total_calls);
        // END Total Calls


        // Total Connected Calls
        this.comparisons.total_connected_calls = this.calculateComparison(this.dashboard_data.total_connected_calls, this.dashboard_data_prev.total_connected_calls);
        // END Total Connected Calls


        // Total Message Leads
        this.comparisons.total_message_leads = this.calculateComparison(this.dashboard_data.total_message_leads, this.dashboard_data_prev.total_message_leads);
        // END Total Message Leads


        // Qualified Leads
        this.comparisons.charged_leads = this.calculateComparison(this.dashboard_data.stats.charged_leads, this.dashboard_data_prev.stats.charged_leads);
        // END Qualified Leads


        // Approved Disputes
        this.comparisons.approved_disputes = this.calculateComparison(this.dashboard_data.stats.approved_disputes, this.dashboard_data_prev.stats.approved_disputes);
        // END Approved Disputes


        // Converted Customers
        this.comparisons.converted_customers = this.calculateComparison(this.dashboard_data.stats.converted_customers, this.dashboard_data_prev.stats.converted_customers);
        // END Converted Customers

        // Converted Customers AI
        this.comparisons.converted_customers_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_ai, this.dashboard_data_prev.stats.converted_customers_ai);
        // END Converted Customers AI

        // Converted Customers NON AI
        this.comparisons.converted_customers_non_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_non_ai, this.dashboard_data_prev.stats.converted_customers_non_ai);
        // END Converted Customers NON AI


        // Conversion
        this.comparisons.conversion = this.calculateComparison(this.dashboard_data.stats.conversion, this.dashboard_data_prev.stats.conversion);
        // END Conversion


        // ROI
        this.comparisons.roi = this.calculateComparison(this.dashboard_data.stats.roi, this.dashboard_data_prev.stats.roi);
        // END ROI


        // Total Converted Value
        this.comparisons.total_converted_value = this.calculateComparison(this.dashboard_data.stats.total_converted_value, this.dashboard_data_prev.stats.total_converted_value);
        // END Total Converted Value


        // LSA Response Rate
        this.comparisons.lsa_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_response_rate, this.dashboard_data_prev.stats.lsa_response_rate);
        // END LSA Response Rate


        // LSA Response in less than 30s Rate
        this.comparisons.lsa_30_seconds_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_30_seconds_response_rate, this.dashboard_data_prev.stats.lsa_30_seconds_response_rate);
        // END LSA Response in less than 30s Rate


        // LSA Messages Average Response Rate
        this.comparisons.lsa_messages_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_messages_response_rate, this.dashboard_data_prev.stats.lsa_messages_response_rate);
        // END LSA Messages Average Response Rate


        // Total Impressions
        this.comparisons.total_impressions = this.calculateComparison(this.dashboard_data.stats.total_impressions, this.dashboard_data_prev.stats.total_impressions);
        // END Total Impressions


        // Total Clicks
        this.comparisons.total_clicks = this.calculateComparison(this.dashboard_data.stats.total_clicks, this.dashboard_data_prev.stats.total_clicks);
        // END Total Clicks


        // Total Cost
        this.comparisons.total_cost = this.calculateComparison(this.dashboard_data.stats.total_cost, this.dashboard_data_prev.stats.total_cost);
        // END Total Cost
      }
  },
  computed: {
      activeHourlyMoRows() {
          const hourly = this.dashboard_data && this.dashboard_data.hourly_missed_opportunities;
          const countColumns = ['Aba 8-', 'Aba 8+', 'MC', 'VM', 'total_calls', 'total_mos'];
          return hourly ? hourly.rows.filter(row => countColumns.some(key => row[key] > 0)) : [];
      },
      ...mapState({
          me: (state) => state.me.me,
          profile: (state) => state.me.profile,
      }),
  },
  created() {
      this.loadDashboard(true);

      if (window.location.href.indexOf('signup') != -1) {
        setTimeout(function() {
          window.location = '/ai-agent?setup_ai=1';
        }, 1000);
      }
  },
};
</script>

<style scoped>
.row-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

th {
  background: rgba(25, 35, 58, 0.1);
}

.number {
  margin-left: 10px; /* Adjust the spacing between the progress bar and the number */
}

.progress-bar {
  background-color: #44468f !important; /* Apply your custom color */
  flex-grow: 1;
  margin-left: 10px; /* Adjust the spacing between the progress bar and the number */
  margin-top: 15px;
}

.setting-header {
  background-color: #fbfbfb;
}

.setting-body {
  background-color: #fdfdfd;
}

.gravatar-pic {
  border-radius: 50%;
  width: 100px;
  display: initial;
  margin-bottom: 6px;
}

.financial-table {
  width: 100%;
  font-size: 12px;
  border-radius: 10px;
}

.financial-table th {
  background: #4EC5A1;
  padding: 10px;
  color: #FFFFFF;
}

.financial-table.two th {
  background: #2e82ad;
  padding: 10px;
  color: #FFFFFF;
}

.financial-table td {
  padding: 10px;
  color: #19233A;
}
</style>
